import { createContext, useContext, useEffect, useState } from "react";
import api from "../services/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [authenticated, setAuthenticated] = useState(true);

  async function loadUser() {
    try {
      const response = await api.get("/api/me");
      setUser(response.data.user);
    } catch {
      setUser(null);
    } finally {
      setLoading(false);
    }
  }

async function login(login, password) {
  // 1. Laravel gera/atualiza o cookie XSRF-TOKEN
  await api.get("/sanctum/csrf-cookie");

  // 2. Lê o token criado pelo Laravel
  const xsrfToken = document.cookie
    .split("; ")
    .find((cookie) => cookie.startsWith("XSRF-TOKEN="))
    ?.split("=")[1];

  if (!xsrfToken) {
    throw new Error("Cookie XSRF-TOKEN não foi criado pelo Laravel.");
  }

  // 3. Envia explicitamente no header
  const response = await api.post(
    "/login",
    {
      login,
      password,
    },
    {
      headers: {
        "X-XSRF-TOKEN": decodeURIComponent(xsrfToken),
      },
    }
  );

  setUser(response.data.user);
  setAuthenticated(true);

  return response.data;
}

  async function logout() {
    try {
      await api.post("/logout");
    } finally {
      setUser(null);
      setAuthenticated(false);
    }
  }

  useEffect(() => {
    loadUser();
  }, []);

  return (
    <AuthContext.Provider
      value={{
        user,
        loading,
        login,
        logout,
        authenticated: Boolean(user),
      }}
    >
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}